<template>
  <div class="profile profile--preview">
    <div class="profile__presentation">
      <profile-header
        :is-current-user="false"
        :user-id="userId"
        :is-c-v-preview="true"
        :user-contact-info="userContactInfo"
      />
      <activities
        :is-current-user="false"
        :is-public-c-v="true"
        :user-id="userId"
      />
    </div>
  </div>
</template>

<script>
// data presentation components
import ProfileHeader from '@/components/profile/ProfileHeader.vue';
import Activities from '@/components/profile/Activities.vue';

import { getUserContactInfoByUserId } from '@/api/profile.js';
import {
  GET_DESCRIPTION,
  GET_USER_CONTACT_INFO,
} from '@/store/mutationTypes.js';

export default {
  name: 'PublicCVPreview',
  components: {
    ProfileHeader,
    Activities,
  },
  props: {
    userId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      userContactInfo: null,
    };
  },
  computed: {
    descriptions() {
      return this.$store.state.descriptions;
    },
  },
  methods: {
    async fetchUserInfo() {
      const { userId } = this;
      const { data, success } = await getUserContactInfoByUserId({ userId });

      if (success) {
        this.userContactInfo = data;
      }
    },
  },
  created() {
    const { userId } = this;

    if (userId) {
      this.fetchUserInfo();
    }

    if (
      !this.descriptions.activityType ||
      this.descriptions.activityType.length === 0
    ) {
      this.$store.dispatch(GET_DESCRIPTION, { key: 'activityType' });
    }
    if (
      !this.descriptions.activityCVLevel ||
      this.descriptions.activityCVLevel.length === 0
    ) {
      this.$store.dispatch(GET_DESCRIPTION, { key: 'activityCVLevel' });
    }
    if (
      !this.descriptions.skillLevel ||
      this.descriptions.skillLevel.length === 0
    ) {
      this.$store.dispatch(GET_DESCRIPTION, { key: 'skillLevel' });
    }
  },
  watch: {
    userId(newVal) {
      if (newVal) {
        this.fetchUserInfo();
      }
    },
  },
};
</script>

<style lang="scss">
@import '~@/styles/shared/_globals.scss';

.profile {
  &--preview {
  }
}
</style>
